import React from 'react'
import { ContactProvider } from './context/ContactContext'
import Header from './components/header/Header'
import Navbar from './components/navbar/Navbar'
import About from './components/about/About'
import Experience from './components/experience/Experience'
import Services from './components/services/Services'
import Portfolio from './components/portfolio/Portfolio'
import Process from './components/process/Process'
import Contact from './components/contact/Contact'
import ContactModal from './components/contact/ContactModal'
import Footer from './components/footer/Footer'

const App = () => {
  return (
    <ContactProvider>
      <div className="app">
        <Navbar />
        <Header />
        <main>
          <About />
          <Process />
          <Services />
          <Experience />
          <Portfolio />
          <Contact />
        </main>
        <Footer />
        <ContactModal />
      </div>
    </ContactProvider>
  )
}

export default App
